import { useState } from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Archive, ArchiveRestore } from "lucide-react";
import api from "@/lib/api";
import { apiErrorMessage } from "@/lib/apiError";

/* R138i · Feb 2026 — Small archive/unarchive toggle used in Project /
   Task detail headers. Renders as a subtle outline button and swaps
   label + endpoint based on current archived_at state. Parent is
   responsible for gating on permissions. */
export default function ArchiveToggle({ kind, entityId, archivedAt, onDone, size = "sm", variant = "outline" }) {
  const [busy, setBusy] = useState(false);
  const isArchived = !!archivedAt;
  const base = kind === "task" ? `/tasks/${entityId}` : `/projects/${entityId}`;
  const label = kind[0].toUpperCase() + kind.slice(1);
  const act = async () => {
    if (busy) return;
    const verb = isArchived ? "unarchive" : "archive";
    if (!isArchived && !window.confirm(`Archive this ${kind}? It will be hidden from default lists.`)) return;
    setBusy(true);
    try {
      await api.post(`${base}/${verb}`);
      toast.success(isArchived ? `${label} restored` : `${label} archived`);
      onDone && onDone();
    } catch (err) {
      toast.error(apiErrorMessage(err, `Failed to ${verb} ${kind}`));
    } finally { setBusy(false); }
  };
  return (
    <Button
      type="button"
      size={size}
      variant={variant}
      onClick={act}
      disabled={busy}
      data-testid={`${kind}-archive-toggle`}
      title={isArchived ? `Restore this ${kind}` : `Archive this ${kind}`}
      className="gap-1.5"
    >
      {isArchived ? <ArchiveRestore className="w-3.5 h-3.5" /> : <Archive className="w-3.5 h-3.5" />}
      <span>{isArchived ? "Unarchive" : "Archive"}</span>
    </Button>
  );
}
